import type { TOC } from '@ember/component/template-only';
import HotelNetRevenueSkeleton from 'lumen/components/hotel/net-revenue/skeleton';

interface HotelNetRevenueSectionHeaderSignature {
  Args: {
    comparisonLabel?: string | null;
    isLoading?: boolean;
    title: string;
  };
  Blocks: {
    right: [];
  };
}

const HotelNetRevenueSectionHeader = <template>
  <div
    class="flex items-center
      {{if (has-block 'right') 'justify-between' 'gap-200'}}"
    data-test-id="net-revenue-section-header"
  >
    <div class="flex items-center gap-200">
      <h2>{{@title}}</h2>
      {{#if @isLoading}}
        <HotelNetRevenueSkeleton
          class="rounded-100 h-200 w-[80px]"
          data-test-id="section-header-comparison-skeleton"
        />
      {{else if @comparisonLabel}}
        <span class="text-300--regular">
          {{@comparisonLabel}}
        </span>
      {{/if}}
    </div>
    {{#if (has-block "right")}}
      {{yield to="right"}}
    {{/if}}
  </div>
</template> satisfies TOC<HotelNetRevenueSectionHeaderSignature>;

export default HotelNetRevenueSectionHeader;
